/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';
import { Panel } from '../../electrons/Panel';
import { Radio } from '../../electrons/forms';

export class Selector extends React.Component {
    onSelect = (value) => {
        if (this.props.onChange && this.props.value !== value) {
            this.props.onChange(value);
        }
    };

    render() {
        const { children, name, className, isContactForm } = this.props;

        return (
            <div className={'p-selector ' + (className || '')}>
                {React.Children.map(
                    children,
                    (Child) =>
                        Child &&
                        React.cloneElement(Child, {
                            name,
                            selected: this.props.value,
                            onSelect: this.onSelect,
                            isContactForm,
                        })
                )}
            </div>
        );
    }
}

Selector.Option = function Option({
    children,
    sentChooseRoleAction,
    name = '',
    value = '',
    selected = '',
    onSelect = () => {},
    disabled = false,
    isContactForm = false,
}) {
    const callback = React.useCallback(
        (e) => {
            e.preventDefault();
            onSelect(value);
            if (typeof sentChooseRoleAction === 'function')
                sentChooseRoleAction(value);
        },
        [onSelect, value]
    );

    return (
        <Panel
            className={
                (value === selected ? 'panel--selected' : '') +
                (disabled ? ' panel--disabled' : '') +
                (isContactForm ? ' form-control' : '')
            }
            onClick={disabled ? null : callback}
        >
            <div className={'p-selector__checkbox'}>
                <Radio
                    name={name}
                    checked={value === selected}
                    onChange={() => false}
                    onClick={callback}
                    disabled={disabled || false}
                />
            </div>
            <div className={'p-selector__label'}>{children}</div>
        </Panel>
    );
};
